import { FactoryProvider } from '@angular/core';
import { BASE_PATH as IdentityServerBasePath } from '@idealsupply/ngclient-webservice-identity-server';

/**
 * The admin SPA is always served by the identity server itself
 * (projects/webservice/Program.cs -> app.UseSpa), so the API is always
 * same-origin.
 *
 * Deriving the path from <base href> rather than hard-coding a host keeps it
 * correct under a sub-path deployment, and - unlike an absolute URL - lets the
 * browser attach the session cookie and lets Angular's HttpXsrfInterceptor
 * attach the X-XSRF-TOKEN header (it skips any URL starting with http:// or
 * https://).
 */
export function identityServerBasePathFactory(): string {
  const baseHref = (typeof document !== 'undefined' && document.baseURI) || '/';
  // 'https://host/'       -> '/v0'
  // 'https://host/admin/' -> '/admin/v0'
  return new URL('v0', baseHref).pathname.replace(/\/+$/, '');
}

export const IDENTITY_SERVER_BASE_PATH_PROVIDER: FactoryProvider = {
  provide: IdentityServerBasePath,
  useFactory: identityServerBasePathFactory,
  deps: [],
};
